<template>
  <div>
    <el-dialog
      :title="title ? title : '提示'"
      :visible.sync="visible"
      @close="handleCancel"
      :show="show"
      :width="width ? width : '350px'"
      :close-on-click-modal="false">
      <div class="text-center" v-if="content">{{content}}</div>
      <div>
        <slot name="boxForm"></slot>
      </div>
      <div slot="footer" class="dialog-footer" v-if="btnTitle">
        <el-button type="primary" @click="handleButton">{{btnTitle}}</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
        <el-button @click="handleCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
      },
      content: {
        type: String,
      },
      width: {
        type: String,
      },
      btnTitle: {
        type: String,
      }
    },
    data() {
      return {
        visible: this.show,
      };
    },
    created() {
    },
    watch: {
      show(val) {
        this.visible = val;
      }
    },
    methods: {
      // 点击弹框下的取消
      handleCancel() {
        this.$emit('getCancel');
      },
      // 点击弹框下的确定
      handleConfirm() {
        this.$emit('getConfirm');
      },
      // 点击弹框下的我知道了
      handleButton() {
        this.$emit('getButton');
      },
    }
  };
</script>

<style lang="less">
  .el-dialog__body {
    padding: 10px 20px !important;
  }
</style>
